<template>
  <Experiment title="expression-alternatives-rating-experiment">

    <InstructionScreen :title="'Welcome'">
      Thanks for taking part in our experiment! The experiment will take approximately 3-4 minutes.
      <br />
      <br />
      In this study would like to ask you to rate different sentences, some of which were generated by machines (large language models), and some by humans.
      The purpose of the ratings is to assess the quality of the machine generations, and your contribution will greatly help us to do so.
      We will NOT use your ratings to train any models, and will only use the ratings for evaluation purposes.
      <br />
      <br />
      You are participating in a study conducted by cognitive scientists at the University of Tübingen. 
      Your participation in this research is voluntary.
      You may decline to answer any or all of the following questions.
      You may decline further participation, at any time, without adverse consequences.
      <br />
      <br />
      Your anonymity is assured; the researchers who have requested your
      participation will not receive any personal information about you.
      <br />
      <br />
      By pressing the button 'Next' you confirm that you are at least 18 years old and agree to participate in this study. 
    </InstructionScreen>

    <InstructionScreen :title="'Instructions'">
      In this study we are interested in how you would rate interpretations of what someone says in an everyday situation.
      <br />
      On each trial, you will be given a short description of a situation where someone utters a sentence.
      Then, you will read four interpretations of that sentence.
      We will ask you to rate how natural you think each interpretation is for what the speaker could plausibly want to convey.
      You'll use sliders to answer the question. 
      <br />
      <br />
      Notice that there will also be simple <b>attention checking trials</b>. 
      You will recognize them immediately when you read the important text on each trial carefully -- those trials contain instructions for you to move the sliders in a certain way. 
      Please follow these instructions on the respective trial. 
      <br />
      <br />
      Please try to respond naturally and reasonably, do not overthink your ratings. <br />
      There will be an example trial on the next screen before the actual experiment starts, so you can familiarize yourself with the task.
    </InstructionScreen>

    <ParallelRatingScreenExample :itemOrder="['lower_bound', 'p1', 'upper_bound', 'p2']" :trial_type="'example'"  />

    <template v-for="(trial, i) in trials">    
      <template v-if="Object.keys(trial).includes('correct_answer')"> 
        <ParallelRatingScreen 
            :trial=trial
            :index=i 
            :trial_type="'filler'" 
            :progress="i / trials.length" 
            :itemOrder="_.shuffle(['lower_bound', 'p1', 'p2', 'upper_bound'])" 
            :correct_answer="trial.correct_answer"
        />    
      </template>  
      <template v-else>
        <ParallelRatingScreen 
            :trial=trial
            :index=i 
            :trial_type="'main'" 
            :progress="i / trials.length" 
            :itemOrder="_.shuffle(['lower_bound', 'p1', 'p2', 'upper_bound'])" 
            :correct_answer="'main'"
        />  
      </template>
    </template>

    <CustomPostTestScreen />

    <SubmitResultsScreen />

  </Experiment>
</template>

<script>
import _ from 'lodash';
import trialsAll from '../trials/updated_trials_randomItems_allVio_processed.csv';
import fillersAll from '../trials/fillers.csv';
import ParallelRatingScreen from './ParallelRatingScreen';
import ParallelRatingScreenExample from './ParallelRatingScreenExample';
import CustomPostTestScreen from './CustomPostTestScreen';

var condition = ['too_much', 'too_little', 'marked', 'irrelevant', 'baseline'];
var maxims = _.sampleSize(['quantity_1', 'quantity_2', 'quality_1', 'quality_2', 'relevance_1', 'manner_1', 'manner_2', 'manner_3', 'manner_4', 'no_violation'], 5);

function filterByCondition(data) {
  const conditionMap = {}
  condition.forEach((item, i) => {
    conditionMap[item] = maxims[i]
  })

  return data.filter(row => {
    return conditionMap[row.inference_type] === row.assumption
  })
}

const n_vignettes = 5;
const n_fillers = 1;

let sampled_trials = [];
do {
  sampled_trials = filterByCondition(trialsAll);
} 
while (sampled_trials.length < n_vignettes);
console.log(sampled_trials);
// const sampled_trials = trialsAll.filter((element, index) => {
//        return _.includes(condition, element['inference_type']);
//      });

// const sampled_trials = _.sampleSize(trials, n_vignettes); //_.sampleSize(trials, n_vignettes).map(x => _.fill(Array(6), x)).flat()

// const fillers =
//   group == 'odd'
//     ? fillersAll.filter((element, index) => {
//         return index % 2 === 0;
//       })
//     : fillersAll.filter((element, index) => {
//         return index % 2 != 0;
//       });

// Disable selecting text
// Supported by the following browsers:
// https://caniuse.com/mdn-api_document_selectstart_event
document.onselectstart = () => false;

// Disable context menu
// Supported by the following browsers:
// https://caniuse.com/mdn-api_element_contextmenu_event
document.oncontextmenu = () => false;

export default {
  name: 'App',
  components: { 
    ParallelRatingScreen,
    ParallelRatingScreenExample,
    CustomPostTestScreen 
  },
  data() {
    return {
      trials: _.shuffle(_.concat( sampled_trials, _.sampleSize(fillersAll, n_fillers))) 
    };
  },
  computed: {
    // Expose lodash to template code
    _() {
      return _;
    }
  }
};
</script>
<style>
body {
  /*
  Disable selecting text via css
  Supported by the following browsers
  https://caniuse.com/mdn-css_properties_user-select
  */
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}
</style>
